export const login = (googleAccessToken: string) =>
  new Promise((resolve, reject) => {
    console.log("login in ...");
    console.log(googleAccessToken);
    setTimeout(() => {
      resolve(true);
    }, 1000);
  });
